import * as React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import useScrollPosition from '@react-hook/window-scroll';
import { WDBLogo } from './svg/Icons';
import { useTopSetter } from './policy/VariantsTable';
import { AffiliateLink } from './AffiliateLink';
import { envBrandPZlow } from '../model/Const';

interface AppNavBarItemProps
{
  iconClassName?: string;
  href: string;
  navClassName?: string;
}

const AppNavBarItem: React.FunctionComponent<AppNavBarItemProps> =
  ({ iconClassName, href, children, navClassName }): JSX.Element =>
  {
    const content = <div className="pl-1 pr-1 d-flex flex-row flex-lg-column">
      {iconClassName &&
        <div className="ml-0 mx-lg-auto">
          <span className={'fas ' + iconClassName} />
        </div>
      }
      <div className="ml-2 mx-lg-auto">{children}</div>
    </div>;

    return (
      <>
        <Nav.Item className={navClassName}>
          <AffiliateLink to={href} className="nav-link" activeClassName="active">
            {content}
          </AffiliateLink>
        </Nav.Item>
      </>
    );
  };

export function AppNavBar(): JSX.Element
{
  const ts = useTopSetter('navHeight');

  const scrollPos = useScrollPosition();
  let headerClass = "bg-light d-flex align-items-center flex-column  sticky-header sticky-padding";

  if (scrollPos > 80)
  {
    headerClass += " header-line";
  }

  return (
    <>
      <header {...ts} className={headerClass} id="header">
        <Navbar expand="lg" variant="light" bg="light" className="px-lg-0 mx-lg-0">
          <Navbar.Brand className="only-mobile">
            <div className="d-flex mobile-center" style={{ width: 250 }}>
              {envBrandPZlow &&
                <Nav.Link href={"https://www.pzlow.pl/"}>
                  <div className="mt-3"><img src="/img/pzlow/logo_pzlow.webp" style={{ width: 'auto', height: 60 }} /></div>
                </Nav.Link>
              }
              <AffiliateLink to={"/#o-fundacji"}>
                <div className="mt-2"><img style={{ width: '90%', height: 'auto' }} src="/img/logo_fundacji.png" /></div>
              </AffiliateLink>
              <AffiliateLink to={"/#o-wdb"}>
                <div className="mt-3"><WDBLogo style={{ width: '100%', height: 'auto' }} /></div>
              </AffiliateLink>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse  >
            <Nav>
              <AppNavBarItem href="/#zakres-ubezpieczenia">
                <div className="d-flex text-center text-nowrap text-red">
                  Zakres ubezpieczenia
                </div>
              </AppNavBarItem>
              <AppNavBarItem href="/#likwidacja">
                <div className="d-flex text-center text-nowrap text-red">
                  Likwidacja szkód
                </div>
              </AppNavBarItem>
              <AppNavBarItem href="/#faq" navClassName="d-flex align-items-center">
                <div className="d-flex align-items-center flex-column text-red">
                  <span>
                    FAQ
                  </span>
                </div>
              </AppNavBarItem>
              <AppNavBarItem href="/#dokumenty" navClassName="d-flex align-items-center">
                <div className="d-flex align-items-center flex-column text-red">
                  <span>
                    Dokumenty
                  </span>
                </div>
              </AppNavBarItem>
              <AppNavBarItem href="/#o-fundacji" navClassName="d-flex align-items-center">
                <div className="d-flex align-items-center flex-column">
                  <span className="text-nowrap text-red">
                    Fundacja
                  </span>
                </div>
              </AppNavBarItem>
              <AppNavBarItem href="/#o-wdb" navClassName="d-flex align-items-center">
                <div className="d-flex align-items-center flex-column">
                  <span className="text-nowrap text-red">
                    WDB S.A.
                  </span>
                </div>
              </AppNavBarItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
    </>
  );
}
